/**
 * Venue_Entity type guard.
 *
 * @param {any} venueJson Venue object from API
 * @returns {boolean} Return true if type is Venue_Entity
 */
function validator(venueJson: unknown): venueJson is Venue_Entity {
  if (typeof venueJson === "object" && venueJson != null) {
    Venue_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(venueJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Venue_Entity {
  static requiredFields = [
    "id",
    "memberID",
    "name",
    "description",
    "coverURL",
    "latitude",
    "longitude",
    "tzName",
    "information",
    "address",
    "city",
    "state",
    "zipcode",
    "sourceID",
    "sourceRecordID",
    "createdAt",
    "updatedAt",
  ];

  constructor(venueJson: unknown) {
    if (validator(venueJson)) {
      this.id = venueJson.id;
      this.memberID = venueJson.memberID;
      this.name = venueJson.name;
      this.description = venueJson.description;
      this.coverURL = venueJson.coverURL;
      this.latitude = venueJson.latitude;
      this.longitude = venueJson.longitude;
      this.tzName = venueJson.tzName;
      this.information = venueJson.information;
      this.address = venueJson.address;
      this.city = venueJson.city;
      this.state = venueJson.state;
      this.zipcode = venueJson.zipcode;
      this.sourceID = venueJson.sourceID;
      this.sourceRecordID = venueJson.sourceRecordID;
      this.createdAt = venueJson.createdAt;
      this.updatedAt = venueJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Venue_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  memberID: number;
  name: string;
  description: string;
  coverURL: string;
  latitude: number;
  longitude: number;
  tzName: string;
  information: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  sourceID: number;
  sourceRecordID: number;
  createdAt: string;
  updatedAt: string;
}
